import React, { useState, useEffect } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate, useLocation } from "react-router-dom";
import "./AddbBlogform.css";
import Swal from "sweetalert2";
import { FaTimes } from "react-icons/fa";

const ViewCareerDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const contactData = location.state?.contactProbsData || {};

  return (
    <div className="modal-overlay  admin_modal_preview create_career_details">
      <div className="custom-modal-content">
        <div className="col-md-12 custom-modal-title text-left">
          <h2 className="mt-0">Contact Details</h2>
        </div>
        <div className="custom-form-group mt-4 closepreview text-right">
          <button
            type="button"
            className="custom-btn-cancel"
            onClick={() => navigate("/contact")}
          >
            <FaTimes />
          </button>
        </div>
        <div className="career-details">
          <div className="col-md-12 form-group">
            <label>Name</label>
            <span>:</span>
            <p> {contactData.name} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Email</label>
            <span>:</span>
            <p> {contactData.email} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Phone</label>
            <span>:</span>
            <p> {contactData.phone} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Subject</label>
            <span>:</span>
            <p> {contactData.subject} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Service</label>
            <span>:</span>
            <p> {contactData.service} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Bussiness</label>
            <span>:</span>
            <p> {contactData.business} </p>
          </div>
          <div className="col-md-12 form-group">
            <label>Bussiness Name</label>
            <span>:</span>
            <p> {contactData.businessName} </p>
          </div><div className="col-md-12 form-group">
            <label>Bussiness Type</label>
            <span>:</span>
            <p> {contactData.businessType} </p>
          </div><div className="col-md-12 form-group">
            <label>Enquiry</label>
            <span>:</span>
            <p> {contactData.enqury} </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCareerDetails;
